<template>
    <Transition name="fade">
        <div class="popup_overlay" v-if="showPopup"></div>
    </Transition>
    
    <Transition name="pop">
        <Popup v-if="showPopup" ref="popup" :selectedBarcode="clickedBarcode" @close-popup="showPopup = false" />
    </Transition>
    
    
    <div id="barcodeTypes">
        <section id="1D-barcodes">
            <header>
                <label>1d symbology</label>
                <h2>{{ one_d_barcode_types_from_widget.section_title }}</h2>
            </header>
            <div class="container">
                <div class="list">
                    <article v-for="barcode in one_d_barcodes" :key="barcode.data_sym_type" :id="'btype'+safeForUrl(barcode.title)">
                        <div class="img">
                            <a v-if="typeof barcode.no_url == 'undefined'" :href="home_url+barcode.path"><img :src="img_path + barcode.slug+'.webp'" :alt="barcode.title" /></a>
                            <img v-else :src="img_path + barcode.slug+'.webp'" :alt="barcode.title" />
                        </div>
                        <div class="data">
                            <header>
                                <h3 v-if="typeof barcode.no_url == 'undefined'" ><a :href="home_url+barcode.path">{{ barcode.title }}</a></h3>
                                <h3 v-else>{{ barcode.title }}</h3>
                            </header>
                            <div class="desc" v-html="barcode.description"></div>
                            <div class="actions">
                                <a @click.prevent="togglePopup(barcode)" :href="home_url+'barcode-types#'+barcode.title" class="button link pale-red fs-14"><svg viewBox="0 0 24 24"><use :xlink:href="spriteHref('qr-scan-plus')"></use></svg>Generate Barcode</a>
                                <a v-if="typeof barcode.no_url == 'undefined'" :href="home_url+barcode.path" class="button link red-text fs-14">More Info<svg viewBox="0 0 16 16"><use :xlink:href="spriteHref('arrow_right_v2')"></use></svg></a>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </section>
        <section id="2D-barcodes">
            <header>
                <label>2d symbology</label>
                <h2>{{ two_d_barcode_types_from_widget.section_title }}</h2>
            </header>
            <div class="container">
                <div class="list">
                    <article v-for="barcode in two_d_barcodes" :id="'btype'+safeForUrl(barcode.title)">
                        <div class="img">
                            <a v-if="typeof barcode.no_url == 'undefined'" :href="home_url+barcode.path"><img :src="img_path + barcode.slug+'.webp'" :alt="barcode.title" /></a>
                            <img v-else :src="img_path + barcode.slug+'.webp'" :alt="barcode.title" />
                        </div>
                        <div class="data">
                            <header>
                                <h3 v-if="typeof barcode.no_url == 'undefined'" ><a :href="home_url+barcode.path">{{ barcode.title }}</a></h3>
                                <h3 v-else>{{ barcode.title }}</h3>
                            </header>
                            <div class="desc" v-html="barcode.description"></div>
                            <div class="actions">
                                <a @click.prevent="togglePopup(barcode)" :href="home_url+'barcode-types#'+barcode.title" class="button link pale-red fs-14"><svg viewBox="0 0 20 20"><use :xlink:href="spriteHref('qr-scan-plus')"></use></svg>Generate Barcode</a>
                                <a v-if="typeof barcode.no_url == 'undefined'" :href="home_url+barcode.path" class="button link red-text fs-14">More Info<svg viewBox="0 0 16 16"><use :xlink:href="spriteHref('arrow_right_v2')"></use></svg></a>
                            </div>
                        </div>
                    </article>
                </div>
            </div>
        </section>
    </div>

</template>

<script>
import Popup from "./components/Popup.vue";
import { oneD_barcodes, twoD_barcodes } from "./constants/pageData";
import { HOME_URL } from "./constants/envrionment";

export default {
    components: {
        Popup,
    },
    data() {
        return {
            img_path: HOME_URL + "themes/barkoder/img/",
            // one_d_barcode_types_from_widget = is available from the php widget view 
            one_d_barcode_types_from_widget: [],
            // two_d_barcode_types_from_widget = is available from the php widget view 
            two_d_barcode_types_from_widget: [],
            env: "",
            home_url: HOME_URL,
            barcode_style: "2d",
            symFilter: "",
            generatedBarcodeUrl: "",
            default_symbologies_info: {},
            symbologies_info: {},
            barcode_style_by_type: {},
            no_data_text: `Loading...`,
            clickedBarcode: null,
            showPopup : false,
            config_items: {
                oneD_barcodes: oneD_barcodes,
                twoD_barcodes: twoD_barcodes,
            }
        };
    },
    computed: {
        one_d_barcodes: function(){

            let self = this,
                res = [];

            for (let index = 0; index < self.config_items.oneD_barcodes.length; index++) {
                
                const item = self.config_items.oneD_barcodes[index];
                
                if(typeof self.one_d_barcode_types_from_widget['barcodes'][item.slug] != 'undefined'){

                    self.config_items.oneD_barcodes[index]['title']         = self.one_d_barcode_types_from_widget['barcodes'][item.slug]['title']
                    self.config_items.oneD_barcodes[index]['img']           = item.slug+'.webp'
                    self.config_items.oneD_barcodes[index]['path']          = self.one_d_barcode_types_from_widget['barcodes'][item.slug]['path']
                    self.config_items.oneD_barcodes[index]['description']   = self.one_d_barcode_types_from_widget['barcodes'][item.slug]['content']

                    res.push(self.config_items.oneD_barcodes[index]);
                }
            }


            return res;
        },
        two_d_barcodes: function(){

            let self = this,
                res = [];

            for (let index = 0; index < self.config_items.twoD_barcodes.length; index++) {
                
                const item = self.config_items.twoD_barcodes[index];
                
                if(typeof self.two_d_barcode_types_from_widget['barcodes'][item.slug] != 'undefined'){

                    self.config_items.twoD_barcodes[index]['title']         = self.two_d_barcode_types_from_widget['barcodes'][item.slug]['title']
                    self.config_items.twoD_barcodes[index]['img']           = item.slug+'.webp'
                    self.config_items.twoD_barcodes[index]['path']          = self.two_d_barcode_types_from_widget['barcodes'][item.slug]['path']
                    self.config_items.twoD_barcodes[index]['description']   = self.two_d_barcode_types_from_widget['barcodes'][item.slug]['content']

                    res.push(self.config_items.twoD_barcodes[index]);
                }
            }


            return res;
        },
    },
    methods: {
        togglePopup(barcode) {
            
            let self = this;

            window.location.hash = '#' + barcode.title

            if (barcode.data_d_type === "1d") {
                let arr = oneD_barcodes.filter(item => item.data_sym_type === barcode.data_sym_type)
                this.clickedBarcode = arr[0]
            }
            else if (barcode.data_d_type === "2d") {
                let arr = twoD_barcodes.filter(item => item.data_sym_type === barcode.data_sym_type)
                this.clickedBarcode = arr[0]
            }

            this.showPopup = !this.showPopup;
        },
        safeForUrl(title) {
            const regex = /\s|\//g;
            return title.replace(regex, "-");
        },
        barcodeLink(title) {
            const regex = /\s|\//g;
            title = title.replace(regex, "-");
            return this.home_url + "barcode-types/" + title.toLowerCase();
        },
        smoothScroll(selector,clickedBarcode){

            let self = this
            var element = document.getElementById(selector);

            var headerOffset = 150;
            var elementPosition = element.getBoundingClientRect().top;
            var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });

            if(clickedBarcode){
                setTimeout(() => {
                    self.togglePopup(clickedBarcode)
                }, 700);
            }
        }

    },

    created: function () {
        let self = this;
        
        if(typeof vue_app_one_d_barcode_types != 'undefined'){
            this.one_d_barcode_types_from_widget = {...vue_app_one_d_barcode_types};
        }

        if(typeof vue_app_two_d_barcode_types != 'undefined'){
            this.two_d_barcode_types_from_widget = {...vue_app_two_d_barcode_types};
        }

        setTimeout(() => {
            if (window.location.hash) {

                
                let hash = decodeURI(window.location.hash.substring(1));
                let clickedBarcode = {};
    
                let arr = this.config_items.oneD_barcodes.filter(item => item.title === hash)
    
                if (arr.length) {
                    clickedBarcode = arr[0]
                }
                else{
                    arr = twoD_barcodes.filter(item => item.title === hash)
                    clickedBarcode = arr[0]
                }

                if (arr.length) {
                    self.smoothScroll('btype'+self.safeForUrl(clickedBarcode.title),clickedBarcode)
                }
                // scroll to element with id#hash
                else{
                    self.smoothScroll(hash)
                }
            }
        }, 500);

    },

};
</script>

<style scoped>
.popup_overlay {
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 999;
    backdrop-filter: blur(3px);
}

.pop-enter-active {
  animation: pop-in 0.4s;
}
.pop-leave-active {
  animation: pop-in 0.4s reverse;
}
@keyframes pop-in {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.fade-enter-active {
  animation: bounce-in 0.2s;
}
.fade-leave-active {
  animation: fade-in 0.2s reverse;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

</style>
